const getTextFromInputEvent = (event: React.FormEvent<HTMLInputElement>): string => {
    const target = event.target as HTMLInputElement;
    return target.value;
};

export default getTextFromInputEvent;
